'use strict';

module.exports = function () {
    /**
     * Segmented Control Logic
     * Maps Segmented Control buttons to their respective Segment Content panels.
     * Panels are scoped to their closest Segmented Control instance based on DOM tree proximity.
     */

    var controls = document.querySelectorAll('.segmented-control');
    var allPagePanels = document.querySelectorAll('.segmented-content');

    if (controls.length === 0 && allPagePanels.length === 0) return;

    // Detect Business Manager Page Designer authoring preview
    function checkIsAuthoring() {
        try {
            var urlList = [window.location.href, document.referrer];
            if (window.parent && window.parent !== window) {
                try {
                    urlList.push(window.parent.location.href);
                } catch (e) {
                    // cross-origin frame access restriction
                }
            }
            var uIdx;
            for (uIdx = 0; uIdx < urlList.length; uIdx += 1) {
                var u = urlList[uIdx];
                if (u && (
                    u.indexOf('ViewLdsBusinessManagerScreen-PageDesigner') > -1 ||
                    u.indexOf('PageDesigner') > -1
                )) {
                    return true;
                }
            }
        } catch (err) {
            return false;
        }
        return false;
    }

    var isAuthoring = checkIsAuthoring();

    // Helper to render authoring notice banner
    function renderAuthorWarning(container, message) {
        if (!isAuthoring || !container) return;
        var existing = container.querySelector ? container.querySelector('.segmented-author-warning') : null;
        if (existing) return;
        var banner = document.createElement('div');
        banner.className = 'segmented-author-warning';
        banner.style.cssText = 'background:#fff3cd;color:#856404;border:1px solid #ffeeba;padding:6px 12px;font-size:11px;font-weight:600;margin:6px 0;border-radius:4px;text-transform:none;';
        banner.textContent = '[Page Designer Notice] ' + message;
        if (container.parentNode) {
            container.parentNode.insertBefore(banner, container);
        } else if (container.insertBefore) {
            container.insertBefore(banner, container.firstChild);
        }
    }

    // Helpers to calculate DOM tree distance (Lowest Common Ancestor)
    function getNodeDepth(node) {
        var depth = 0;
        var curr = node;
        while (curr && curr.parentNode) {
            depth += 1;
            curr = curr.parentNode;
        }
        return depth;
    }

    function getLowestCommonAncestor(nodeA, nodeB) {
        var ancestorsA = [];
        var currA = nodeA;
        while (currA) {
            ancestorsA.push(currA);
            currA = currA.parentNode;
        }
        var currB = nodeB;
        while (currB) {
            if (ancestorsA.indexOf(currB) !== -1) {
                return currB;
            }
            currB = currB.parentNode;
        }
        return null;
    }

    function getNodeDistance(nodeA, nodeB) {
        var lca = getLowestCommonAncestor(nodeA, nodeB);
        if (!lca) return 999999;
        var depthA = getNodeDepth(nodeA);
        var depthB = getNodeDepth(nodeB);
        var depthLca = getNodeDepth(lca);
        return (depthA - depthLca) + (depthB - depthLca);
    }

    function isPanelEmpty(panel) {
        if (!panel) return true;
        if (panel.children.length === 0 && !panel.textContent.trim()) return true;
        var region = panel.querySelector('.experience-region');
        if (region && region.children.length === 0 && !region.textContent.trim()) return true;
        return false;
    }

    // 1. Assign each panel on the page to its closest matching control
    var pIdx;
    for (pIdx = 0; pIdx < allPagePanels.length; pIdx += 1) {
        var currentPanel = allPagePanels[pIdx];
        if (isPanelEmpty(currentPanel)) {
            currentPanel.classList.add('is-empty');
        }
        var panelSegmentId = currentPanel.getAttribute('data-segment-id');
        if (!panelSegmentId) {
            renderAuthorWarning(currentPanel, 'Segment Content is missing required Segment ID.');
            currentPanel.style.display = 'none';
            currentPanel.setAttribute('aria-hidden', 'true');
        } else {
            // Find candidate controls that have a button matching this panel's segmentId
            var candidateControls = [];
            var cIdx;
            for (cIdx = 0; cIdx < controls.length; cIdx += 1) {
                var ctrlItem = controls[cIdx];
                var ctrlButtons = ctrlItem.querySelectorAll('.segmented-button');
                var matchingButton = null;
                var bScan;
                for (bScan = 0; bScan < ctrlButtons.length; bScan += 1) {
                    if (ctrlButtons[bScan].getAttribute('data-segment-id') === panelSegmentId) {
                        matchingButton = ctrlButtons[bScan];
                        break;
                    }
                }
                if (matchingButton) {
                    candidateControls.push(ctrlItem);
                }
            }

            var ownerControl = null;
            if (candidateControls.length === 1) {
                ownerControl = candidateControls[0];
            } else if (candidateControls.length > 1) {
                // Pick control with shortest tree distance
                var shortestDist = Infinity;
                var candIdx;
                for (candIdx = 0; candIdx < candidateControls.length; candIdx += 1) {
                    var candidate = candidateControls[candIdx];
                    var dist = getNodeDistance(candidate, currentPanel);
                    if (dist < shortestDist) {
                        shortestDist = dist;
                        ownerControl = candidate;
                    }
                }
            }

            if (ownerControl) {
                var matchedControlId = ownerControl.getAttribute('data-control-id');
                currentPanel.setAttribute('data-control-id', matchedControlId);
            } else {
                // Orphaned panel (no matching control on page)
                currentPanel.setAttribute('data-control-id', 'orphaned');
                renderAuthorWarning(currentPanel, 'Segment Content ("' + panelSegmentId + '") has no matching Segment Button.');
                if (!isAuthoring) {
                    currentPanel.style.display = 'none';
                    currentPanel.setAttribute('aria-hidden', 'true');
                }
            }
        }
    }

    // 2. Initialize each Segmented Control
    var ctrlIndex;
    for (ctrlIndex = 0; ctrlIndex < controls.length; ctrlIndex += 1) {
        (function (ctrl) {
            var controlId = ctrl.getAttribute('data-control-id');
            var buttons = ctrl.querySelectorAll('.segmented-button');

            if (buttons.length === 0) {
                ctrl.classList.add('is-empty');
                return;
            }

            var controlPanels = document.querySelectorAll('.segmented-content[data-control-id="' + controlId + '"]');

            // Track active timeouts to handle rapid clicks
            var transitionTimers = [];
            var activeContainers = [];

            function clearAllTimers() {
                var t;
                for (t = 0; t < transitionTimers.length; t += 1) {
                    clearTimeout(transitionTimers[t]);
                }
                transitionTimers = [];

                var c;
                for (c = 0; c < activeContainers.length; c += 1) {
                    var ac = activeContainers[c];
                    if (ac) {
                        ac.style.transition = 'none';
                    }
                }
            }

            // Establish ARIA tab / tabpanel relationships
            var bIdx;
            for (bIdx = 0; bIdx < buttons.length; bIdx += 1) {
                var btn = buttons[bIdx];
                var btnSegmentId = btn.getAttribute('data-segment-id');
                if (!btnSegmentId) {
                    renderAuthorWarning(ctrl, 'Segment Button has no Segment ID.');
                } else {
                    var tabId = 'tab-' + controlId + '-' + btnSegmentId;
                    btn.setAttribute('id', tabId);
                    btn.setAttribute('role', 'tab');

                    // Find all matching panels for this button within this control
                    var matchingPanels = [];
                    var cpIdx;
                    for (cpIdx = 0; cpIdx < controlPanels.length; cpIdx += 1) {
                        var cp = controlPanels[cpIdx];
                        if (cp.getAttribute('data-segment-id') === btnSegmentId) {
                            matchingPanels.push(cp);
                        }
                    }

                    if (matchingPanels.length === 0) {
                        renderAuthorWarning(ctrl, 'Segment Button "' + (btn.textContent.trim()) + '" ("' + btnSegmentId + '") has no matching Segment Content.');
                    }

                    var panelIds = [];
                    var mpIdx;
                    for (mpIdx = 0; mpIdx < matchingPanels.length; mpIdx += 1) {
                        var matchedPanel = matchingPanels[mpIdx];
                        var pId = 'panel-' + controlId + '-' + btnSegmentId + (mpIdx > 0 ? '-' + mpIdx : '');
                        matchedPanel.setAttribute('id', pId);
                        matchedPanel.setAttribute('role', 'tabpanel');
                        matchedPanel.setAttribute('tabindex', '-1');
                        matchedPanel.setAttribute('aria-labelledby', tabId);
                        panelIds.push(pId);
                    }

                    if (panelIds.length > 0) {
                        btn.setAttribute('aria-controls', panelIds.join(' '));
                    }
                }
            }

            // Determine default button
            // FR-10: Two or more buttons with Is Selected by Default: first of them is selected on load
            var defaultBtn = null;
            var defIdx;
            for (defIdx = 0; defIdx < buttons.length; defIdx += 1) {
                var checkBtn = buttons[defIdx];
                if (checkBtn.getAttribute('data-is-default') === 'true' && !defaultBtn) {
                    defaultBtn = checkBtn;
                }
            }
            if (!defaultBtn) {
                defaultBtn = buttons[0];
            }

            // Helper to find the common layout container enclosing content panels
            function getContentContainer(panelA, panelB) {
                var container = null;
                if (panelA && panelB) {
                    container = getLowestCommonAncestor(panelA, panelB);
                }
                if (!container && (panelA || panelB)) {
                    var ref = panelA || panelB;
                    var curr = ref.parentElement;
                    while (curr && curr !== document.body && curr !== document.documentElement) {
                        if (curr.classList && (
                            curr.classList.contains('experience-region') ||
                            curr.classList.contains('two-col-layout__region') ||
                            curr.classList.contains('three-col-layout__region') ||
                            curr.classList.contains('col-12') ||
                            curr.classList.contains('col-md-6')
                        )) {
                            container = curr;
                            break;
                        }
                        curr = curr.parentElement;
                    }
                    if (!container && ref.parentElement) {
                        if (ref.parentElement.classList && ref.parentElement.classList.contains('experience-component')) {
                            container = ref.parentElement.parentElement || ref.parentElement;
                        } else {
                            container = ref.parentElement;
                        }
                    }
                }
                if (container && (
                    container === document.body ||
                    container === document.documentElement ||
                    (container.classList && (
                        container.classList.contains('page') ||
                        container.classList.contains('experience-page')
                    ))
                )) {
                    return null;
                }
                return container;
            }

            function activateSegment(selectedBtn, isInitialLoad) {
                var targetId = selectedBtn.getAttribute('data-segment-id');
                if (!targetId) return;

                clearAllTimers();

                // Update buttons
                var updateBtnIdx;
                for (updateBtnIdx = 0; updateBtnIdx < buttons.length; updateBtnIdx += 1) {
                    var b = buttons[updateBtnIdx];
                    var isSelected = (b === selectedBtn);
                    b.setAttribute('aria-selected', isSelected.toString());
                    if (isSelected) {
                        b.classList.add('is-active');
                    } else {
                        b.classList.remove('is-active');
                    }
                }

                var outgoingPanels = [];
                var incomingPanels = [];

                var panelScanIdx;
                for (panelScanIdx = 0; panelScanIdx < controlPanels.length; panelScanIdx += 1) {
                    var p = controlPanels[panelScanIdx];
                    var panelId = p.getAttribute('data-segment-id');
                    if (panelId === targetId) {
                        incomingPanels.push(p);
                    } else if (p.classList.contains('is-active') || p.classList.contains('is-entering')) {
                        outgoingPanels.push(p);
                    } else {
                        p.classList.remove('is-active', 'is-entering', 'is-exiting', 'is-entering-initial');
                        p.setAttribute('aria-hidden', 'true');
                        p.style.display = 'none';
                    }
                }

                if (isInitialLoad) {
                    // Show incoming panels immediately on load
                    var initInIdx;
                    for (initInIdx = 0; initInIdx < incomingPanels.length; initInIdx += 1) {
                        var inP = incomingPanels[initInIdx];
                        inP.classList.remove('is-entering', 'is-exiting', 'is-entering-initial');
                        inP.classList.add('is-active');
                        inP.setAttribute('aria-hidden', 'false');
                        inP.style.display = 'block';

                        if (window.jQuery) {
                            window.jQuery(inP).find('.slick-slider').slick('setPosition');
                        }
                    }

                    var initOutIdx;
                    for (initOutIdx = 0; initOutIdx < outgoingPanels.length; initOutIdx += 1) {
                        var outP = outgoingPanels[initOutIdx];
                        outP.classList.remove('is-active', 'is-entering', 'is-exiting', 'is-entering-initial');
                        outP.setAttribute('aria-hidden', 'true');
                        outP.style.display = 'none';
                    }
                    return;
                }

                // FR-21: Smooth height transition between outgoing and incoming content
                var containersToAnimate = [];
                var maxCount = Math.max(outgoingPanels.length, incomingPanels.length);
                var cPairIdx;
                for (cPairIdx = 0; cPairIdx < maxCount; cPairIdx += 1) {
                    var outPanelRef = outgoingPanels[cPairIdx] || null;
                    var inPanelRef = incomingPanels[cPairIdx] || null;
                    var candCont = getContentContainer(outPanelRef, inPanelRef);
                    if (candCont && containersToAnimate.indexOf(candCont) === -1) {
                        containersToAnimate.push(candCont);
                    }
                }

                var containerData = [];
                var contIdx;
                for (contIdx = 0; contIdx < containersToAnimate.length; contIdx += 1) {
                    var contElem = containersToAnimate[contIdx];
                    var startH = contElem.offsetHeight;
                    containerData.push({
                        element: contElem,
                        startHeight: startH,
                        targetHeight: startH
                    });
                }

                // Synchronously measure target natural height
                var pMeasureIdx;
                for (pMeasureIdx = 0; pMeasureIdx < outgoingPanels.length; pMeasureIdx += 1) {
                    outgoingPanels[pMeasureIdx].style.display = 'none';
                }
                for (pMeasureIdx = 0; pMeasureIdx < incomingPanels.length; pMeasureIdx += 1) {
                    incomingPanels[pMeasureIdx].style.display = 'block';
                    incomingPanels[pMeasureIdx].style.visibility = 'hidden';
                }

                for (contIdx = 0; contIdx < containerData.length; contIdx += 1) {
                    var data = containerData[contIdx];
                    var savedHeight = data.element.style.height;
                    var savedTrans = data.element.style.transition;
                    data.element.style.height = 'auto';
                    data.element.style.transition = 'none';
                    data.targetHeight = data.element.offsetHeight;
                    data.element.style.height = savedHeight;
                    data.element.style.transition = savedTrans;
                }

                // Restore panels to Phase 1 state
                for (pMeasureIdx = 0; pMeasureIdx < incomingPanels.length; pMeasureIdx += 1) {
                    incomingPanels[pMeasureIdx].style.display = 'none';
                    incomingPanels[pMeasureIdx].style.visibility = '';
                }
                for (pMeasureIdx = 0; pMeasureIdx < outgoingPanels.length; pMeasureIdx += 1) {
                    outgoingPanels[pMeasureIdx].style.display = 'block';
                }

                // Lock container heights during Phase 1 so nothing jumps
                for (contIdx = 0; contIdx < containerData.length; contIdx += 1) {
                    var lockData = containerData[contIdx];
                    if (lockData.startHeight > 0) {
                        lockData.element.style.height = lockData.startHeight + 'px';
                        lockData.element.style.overflow = 'hidden';
                    }
                }

                activeContainers = containersToAnimate;
                var prefersReducedMotion = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

                // Phase 1 (Out): Outgoing fades out over 120ms (ease-in)
                var startOutIdx;
                for (startOutIdx = 0; startOutIdx < outgoingPanels.length; startOutIdx += 1) {
                    var exitingP = outgoingPanels[startOutIdx];
                    exitingP.classList.remove('is-active', 'is-entering', 'is-entering-initial');
                    exitingP.classList.add('is-exiting');
                    exitingP.style.display = 'block';
                }

                var timer1 = setTimeout(function () {
                    // Phase 1 finished: hide outgoing
                    var finishOutIdx;
                    for (finishOutIdx = 0; finishOutIdx < outgoingPanels.length; finishOutIdx += 1) {
                        var outDoneP = outgoingPanels[finishOutIdx];
                        outDoneP.classList.remove('is-exiting', 'is-active');
                        outDoneP.style.display = 'none';
                        outDoneP.setAttribute('aria-hidden', 'true');
                    }

                    // Phase 2 (In): Incoming fades in and shifts up 4px -> 0 over 200ms (translate dropped for reduced motion in CSS)
                    var startInIdx;
                    for (startInIdx = 0; startInIdx < incomingPanels.length; startInIdx += 1) {
                        var enteringP = incomingPanels[startInIdx];
                        if (isPanelEmpty(enteringP)) {
                            enteringP.classList.add('is-empty');
                        }
                        enteringP.classList.remove('is-active', 'is-exiting');
                        enteringP.classList.add('is-entering-initial');
                        enteringP.style.display = 'block';
                        enteringP.setAttribute('aria-hidden', 'false');

                        // Force browser reflow so transition start state is applied
                        if (enteringP.offsetHeight) {
                            // intentional reflow trigger
                        }

                        enteringP.classList.remove('is-entering-initial');
                        enteringP.classList.add('is-entering');

                        if (window.jQuery) {
                            window.jQuery(enteringP).find('.slick-slider').slick('setPosition');
                        }
                    }

                    // Smooth height transition alongside Phase 2 fade-in
                    var animContIdx;
                    for (animContIdx = 0; animContIdx < containerData.length; animContIdx += 1) {
                        var animInfo = containerData[animContIdx];
                        if (!prefersReducedMotion && animInfo.startHeight !== animInfo.targetHeight) {
                            animInfo.element.style.transition = 'height 200ms cubic-bezier(0, 0, 0.2, 1)';
                            animInfo.element.style.height = animInfo.targetHeight + 'px';
                        } else if (animInfo.targetHeight > 0) {
                            animInfo.element.style.height = animInfo.targetHeight + 'px';
                        } else {
                            animInfo.element.style.height = '';
                        }
                    }

                    var timer2 = setTimeout(function () {
                        // Phase 2 finished: settle
                        var finishInIdx;
                        for (finishInIdx = 0; finishInIdx < incomingPanels.length; finishInIdx += 1) {
                            var settledP = incomingPanels[finishInIdx];
                            settledP.classList.remove('is-entering', 'is-entering-initial');
                            settledP.classList.add('is-active');

                            // FR-26: Move focus to newly selected segment's content region after in phase
                            settledP.focus();

                            // FR-22: Carousel inside segment re-measures
                            if (window.jQuery) {
                                window.jQuery(settledP).find('.slick-slider').slick('setPosition');
                            }
                            settledP.dispatchEvent(new CustomEvent('component:panel:revealed'));
                        }

                        // Restore container styles to natural document flow
                        var settleContIdx;
                        for (settleContIdx = 0; settleContIdx < containerData.length; settleContIdx += 1) {
                            var settleInfo = containerData[settleContIdx];
                            settleInfo.element.style.height = '';
                            settleInfo.element.style.transition = '';
                            settleInfo.element.style.overflow = '';
                        }
                        activeContainers = [];

                        window.dispatchEvent(new Event('resize'));
                    }, 200);

                    transitionTimers.push(timer2);
                }, outgoingPanels.length > 0 ? 120 : 0);

                transitionTimers.push(timer1);
            }

            // Initialize default segment on page load
            activateSegment(defaultBtn, true);

            // Bind clicks and keyboard events
            var bindIdx;
            for (bindIdx = 0; bindIdx < buttons.length; bindIdx += 1) {
                (function (currentBtn) {
                    currentBtn.addEventListener('click', function (e) {
                        e.preventDefault();
                        if (currentBtn.getAttribute('aria-selected') === 'true') return;
                        activateSegment(currentBtn, false);
                    });

                    // WAI-ARIA Tabs keyboard navigation
                    currentBtn.addEventListener('keydown', function (e) {
                        var btnList = Array.from(buttons);
                        var index = btnList.indexOf(currentBtn);
                        var nextIndex = -1;

                        if (e.key === 'ArrowRight' || e.key === 'Right') {
                            nextIndex = (index + 1) % btnList.length;
                        } else if (e.key === 'ArrowLeft' || e.key === 'Left') {
                            nextIndex = ((index - 1) + btnList.length) % btnList.length;
                        } else if (e.key === 'Home') {
                            nextIndex = 0;
                        } else if (e.key === 'End') {
                            nextIndex = btnList.length - 1;
                        } else if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            if (currentBtn.getAttribute('aria-selected') !== 'true') {
                                activateSegment(currentBtn, false);
                            }
                            return;
                        }

                        if (nextIndex !== -1) {
                            e.preventDefault();
                            btnList[nextIndex].focus();
                        }
                    });
                }(buttons[bindIdx]));
            }

            // FR-16: the scrollbar is hidden, so a mouse wheel (vertical) scrolls an overflowing control horizontally.
            // Only while it can still scroll that way, so the page keeps scrolling once an edge is reached.
            ctrl.addEventListener('wheel', function (e) {
                var maxScroll = ctrl.scrollWidth - ctrl.clientWidth;
                if (maxScroll <= 0 || Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;

                var atStart = ctrl.scrollLeft <= 0 && e.deltaY < 0;
                var atEnd = ctrl.scrollLeft >= maxScroll - 1 && e.deltaY > 0;
                if (atStart || atEnd) return;

                // deltaMode 1 = lines (e.g. Firefox with a mouse), 2 = pages; scrollBy expects pixels
                var delta = e.deltaY;
                if (e.deltaMode === 1) {
                    delta *= 16;
                } else if (e.deltaMode === 2) {
                    delta *= ctrl.clientWidth;
                }

                e.preventDefault();
                ctrl.scrollBy(delta, 0);
            }, { passive: false });

            // Mouse drag-to-scroll, the desktop equivalent of a touch swipe (touch already scrolls natively).
            // Scrolling starts after a 5px move, and the click that ends a drag does not select a segment.
            var drag = null;
            var suppressClick = false;

            ctrl.addEventListener('pointerdown', function (e) {
                suppressClick = false;
                if (e.pointerType !== 'mouse' || e.button !== 0 || ctrl.scrollWidth <= ctrl.clientWidth) return;
                drag = { x: e.clientX, left: ctrl.scrollLeft, moved: false };
            });

            ctrl.addEventListener('pointermove', function (e) {
                if (!drag) return;
                var dx = e.clientX - drag.x;
                if (!drag.moved) {
                    if (Math.abs(dx) < 5) return;
                    drag.moved = true;
                    ctrl.setPointerCapture(e.pointerId);
                    ctrl.classList.add('is-dragging');
                }
                ctrl.scrollTo(drag.left - dx, 0);
            });

            function endDrag(e) {
                if (!drag) return;
                suppressClick = drag.moved;
                drag = null;
                ctrl.classList.remove('is-dragging');
                if (ctrl.hasPointerCapture(e.pointerId)) {
                    ctrl.releasePointerCapture(e.pointerId);
                }
            }

            ctrl.addEventListener('pointerup', endDrag);
            ctrl.addEventListener('pointercancel', endDrag);

            // Capture phase: stops the post-drag click before it reaches a segment button
            ctrl.addEventListener('click', function (e) {
                if (!suppressClick) return;
                suppressClick = false;
                e.preventDefault();
                e.stopPropagation();
            }, true);
        }(controls[ctrlIndex]));
    }
};
